import { type IconProps } from '@ironhack/design-system2/components/icon';
import {
  Tag as DsTag,
  type TagProps as DsTagProps,
} from '@ironhack/design-system2/components/tag';
import { backgroundToTokens } from '@ironhack/design-system2/utils';
import { type ReactElement } from 'react';

import { Icon } from '@/app/components/server/icon';
import {
  type DatoBackgroundColor,
  type DatoIconBlock,
} from '@/lib/datocms/types';

export type TagProps = {
  icon?: DatoIconBlock | null;
  iconProps?: IconProps;
  tagBackground: DatoBackgroundColor;
  textColor: { fillColor: string } | null;
} & Omit<DsTagProps, 'icon'>;

export const Tag = (props: TagProps): ReactElement => {
  const {
    icon,
    iconProps,
    tagBackground: { backgroundColor },
    textColor,
    textStyle,
    ...tagProps
  } = props;

  const { color } = backgroundToTokens(backgroundColor);
  const tagIconProp = icon
    ? { icon: () => <Icon icon={icon} {...iconProps} /> }
    : null;

  return (
    <DsTag
      color={textColor ? `fill.${textColor.fillColor}` : color}
      colorScheme={backgroundColor}
      textProps={{ textStyle }}
      {...tagIconProp}
      {...tagProps}
    />
  );
};
